import { queryOptions } from '@tanstack/react-query';

import { getQueryFn } from '../utils';
import { Zoo } from './types';

// eslint-disable-next-line import/prefer-default-export
export const getZoosQueryOptions = () =>
  queryOptions({
    queryKey: ['zoos', 'list'],
    queryFn: getQueryFn<{ zoos: Zoo[] }>('/zoos'),
    select: ({ zoos }) => zoos,
  });

export const getZooQueryOptions = (zooId: string | null | undefined) =>
  queryOptions({
    queryKey: ['zoos', 'detail', zooId],
    queryFn: getQueryFn<Zoo>(`/zoos/${zooId}`),
    enabled: Boolean(zooId),
  });
